import React, { useContext, useEffect } from 'react'
import ConfigsContext from '../context/ConfigsContext';
import { BsFillArrowLeftCircleFill } from "react-icons/bs";
import {
  BsWhatsapp,
  BsFacebook,
  BsInstagram,
} from "react-icons/bs";
import getData from '../services/firebase/dataService';
import { gallerySection } from '../domain/sectionDomains';
import getImage from '../services/firebase/imageService';

import logo from './../assets/logo.png';

const Gallery = () => {
  const {
    top,
    pageConfig,
    setGallery,
    gallery,
  } = useContext(ConfigsContext);

  async function setGalleryArray() {
    const gallery = await getData(gallerySection.gallery.hash)
    const array = [];
  
    gallery.forEach(async (element) => {
      const thisImg = await getImage(element.imagem.fullPath)
      array.push(thisImg)
    })
  
    setGallery(array);
  }

  useEffect(() => {
    setGalleryArray();
  }, [])
  
  const { color } = pageConfig;

  const navigation = [
    {
      name: 'WhatsApp',
      href: 'https://api.whatsapp.com/send/?phone=5514997065191&text&type=phone_number&app_absent=0',
      icon: <BsWhatsapp />
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/armazemdvitto/',
      icon: <BsInstagram />
    },
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/ArmazemDVitto',
      icon: <BsFacebook />
    },
  ]
  
  return (
    <div style={ {backgroundColor: '#9999' } } className="h-screen">
      <header className="bg-gray1 fixed top-0 z-30 w-full flex flex-row justify-center items-center px-4 h-[5rem]">
        <div className="flex flex-row items-center justify-center">    
          <a href="https://armazemdvitto.com.br">
            <img className="h-16 px-4 my-4 cursor-pointer" src={ top.logo } alt="Logo Armazém D'Vitto" />
          </a>
        </div>
        <nav className="flex flex-row w-24 md:w-32 justify-evenly">
          {navigation.map((item) => (
            <a key={item.name} href={item.href} className="text-white opacity-80 hover:opacity-100 hover:scale-125 ease-out duration-150 hover:text-white" target="_blank" rel="noreferrer">
              <span className="sr-only">{item.name}</span>
              {item.icon}
            </a>
          ))}
        </nav>
      </header>
      <section className="text-center h-[calc(100%-5rem)] fixed mt-[5rem]">
        <div className="flex flex-row items-center p-3 pb-0 h-[4rem]">
          <a href="https://armazemdvitto.com.br" className="top-18 right-4 py-4 pr-8">
            <BsFillArrowLeftCircleFill style={ { color: `${ color }`, stroke: 'rgba(153, 153, 153, 0.9)', strokeWidth: 0.5} } className="h-12 p-1 w-12 hover:scale-110 duration-150" />
          </a> 
          <h2 style={ { color: `${ color }`} } className="font-bold text-3xl text-left">Nossa Casa</h2>
        </div>
        <div className="m-3 mt-3 mb-4 h-[calc(100%-5.75rem)] flex flex-col md:flex-row overflow-x-auto">
          {
            gallery?.array && gallery.array.map((img, i) => (
              <img key={i} className="w-screen h-auto rounded border-4 border-white my-2 first:mt-0 last:mb-0 md:my-0 md:mx-1 md:first:ml-0 md:last:mr-0" src={img} alt="" />
            ))
          }
        </div>
      </section>
    </div>

  )
}

export default Gallery;
